import { render, staticRenderFns } from "./TrustPoints.vue?vue&type=template&id=f8d4407e&scoped=true&"
import script from "./TrustPoints.vue?vue&type=script&lang=js&"
export * from "./TrustPoints.vue?vue&type=script&lang=js&"
import style0 from "./TrustPoints.vue?vue&type=style&index=0&id=f8d4407e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d4407e",
  null
  
)

export default component.exports